/**
 * Canonical `FORM_CONTEXT_VERSION` constant — extracted from form-context.tsx
 * so it can be imported without pulling in React or Next.js dependencies.
 *
 * The E2E spec imports this directly (BS-2170 #3) so a version bump causes an
 * explicit import-time mismatch rather than a silent seed-staleness failure.
 *
 * Bump this AND document why any time the persisted form schema changes in a
 * non-backward-compatible way:
 *   - field rename
 *   - field added with required: true
 *   - nested shape change
 *
 * Keep in sync with the `FORM_CONTEXT_VERSION` re-export in
 * `src/lib/providers/form-context.tsx`.
 */
export const FORM_CONTEXT_VERSION = 1 as const;
